import { default as AbstractModal } from './AbstractModal'
import { CUSTOM_EVENT } from '../config'
import { $html, $header } from '../utils/dom'

export default class ModalMenu extends AbstractModal {

    static get settings() {
        return {
            CLASS_OPEN: 'has-menu-open',
            CLASS_ITEM_ACTIVE: 'is-active',
        }
    }

    constructor(m) {
        super(m)

        // DOM
        this.$items = Array.from(this.$('item'))
        this.$focusTrapContainer = $header

        // Vars
        this.activeMenuItemIndex = 0

        // Events
        this.events = {
            click: {
                'open': 'open',
                'close': 'close',
            },
            mouseenter: {
                'item': 'onItemHover',
            },
        }
    }

    onInit() {
        // this.setItem(0)
        window.addEventListener(CUSTOM_EVENT.RESIZE_END, this.onResize = () => this.close())
    }

    onOpen() {
        $html.classList.add(ModalMenu.settings.CLASS_OPEN)
        // this.call('start', null, 'SceneMenu')
        this.setItem(this.activeMenuItemIndex, true)
        this.call('onMenuOpen', null, 'Header')
    }

    onClose() {
        $html.classList.remove(ModalMenu.settings.CLASS_OPEN)
        this.call('animate', -1, 'SceneMenu')
        // this.setItem(this.activeMenuItemIndex)

        // this.call('stop', null, 'SceneMenu')
        this.call('onMenuClose', null, 'Header')
    }

    toggle() {
        if(this.isOpen) {
            this.close()
        } else {
            this.open()
        }
    }

    onItemHover(e) {
        const index = this.$items.findIndex($item => $item === e.curTarget)

        if(index >= 0) {
            this.setItem(index)
        }
    }

    setItem(index, force=false) {

        if(this.activeMenuItemIndex === index && !force) {
            return
        }

        if(this.activeMenuItemIndex >= 0) {
            this.$items[this.activeMenuItemIndex]?.classList.remove(ModalMenu.settings.CLASS_ITEM_ACTIVE)
        }

        this.$items[index]?.classList.add(ModalMenu.settings.CLASS_ITEM_ACTIVE)
        this.call('animate', index, 'SceneMenu')
        this.activeMenuItemIndex = index
    }
}
